import {
  DownloadIcon,
  lightColorPalette,
  LinkIcon,
  Snackbar
} from '@linearb/linui-common';
import MenuButton, { MenuButtonItem } from 'components/MenuButton';
import { useState } from 'react';
import { copyAsMarkdown, copyLink } from './iteration-summary.utils';
import { useSelector } from 'react-redux';
import { organizationSelector } from 'state/selectors/organization';

const ShareMenu = ({ data, iterationRange, trackingEventsHandler }) => {
  const [snackbarMessage, setSnackbarMessage] = useState(null);
  const [errorMessages, setErrorMessages] = useState(null);

  const iterationId = data?.iteration_id;
  const teamId = data?.team_id;
  const organization = useSelector(organizationSelector);

  const onCopyLink = async () => {
    try {
      await copyLink({
        iterationId,
        teamId,
        organizationId: organization.id
      });
      setSnackbarMessage('Link copied to clipboard');
      trackingEventsHandler.onCopyLink();
    } catch (error) {
      setErrorMessages('Error copying link');
    }
  };

  const onCopyAsMarkdown = async () => {
    try {
      await copyAsMarkdown({ data, iterationRange });
      setSnackbarMessage('Markdown text copied to clipboard');
      trackingEventsHandler.onCopyMarkdown();
    } catch (error) {
      setErrorMessages('Error copying markdown text');
    }
  };

  const items = [
    <MenuButtonItem
      key='copy-link'
      id='copy-link'
      text='Copy link'
      icon={<LinkIcon color={lightColorPalette.lbBlue_60} />}
      onClick={onCopyLink}
    />,
    <MenuButtonItem
      key='copy-as-markdown'
      id='copy-as-markdown'
      text='Copy as Markdown text'
      icon={<DownloadIcon color={lightColorPalette.lbBlue_60} />}
      onClick={onCopyAsMarkdown}
    />
  ];

  return (
    <>
      <MenuButton
        items={items}
        buttonText='Share'
        width='auto'
        onHover={trackingEventsHandler.onShareButtonHover}
      />
      <Snackbar
        type='success'
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackbarMessage}
        handleClose={() => setSnackbarMessage(null)}
        autoHideDuration={6000}
      >
        {snackbarMessage}
      </Snackbar>
      <Snackbar
        type='error'
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={errorMessages}
        handleClose={() => setErrorMessages(null)}
        autoHideDuration={6000}
      >
        {errorMessages}
      </Snackbar>
    </>
  );
};

export default ShareMenu;
